var isPage = "";
var Animate = {
	top: 0,
	show: 0
}
var animations = [];
var common = {
	init: ()=>{
		var resizeFlag;
		var resizeTimer = null;
		var $body = $("body");

		page.init();
		
		/* window resize
		----------------------------- */
		var resizeCallback = function() {
			common.resize();
			page.resizeGL();
			resizeTimer = null;
		};

		$(window).off("resize").on("resize",function(){
			if(!$body.hasClass("resize")){
				$body.addClass("resize");
			}
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(resizeCallback, 300);
		});

	},
	getJson : function(url){
		var defer = $.Deferred();
		$.ajax({
			type: "GET",
			dataType: 'json',
			url: url,
			success : defer.resolve,
			error: defer.reject
		});
		return defer.promise();
	},
	nav: ()=>{
		let $body 	= $("body"),
			$header = $("header#global_header"),
			hoverFlag = false;
		$("#glbnav_pc ul li").eq(1).find("a").on({
			"mouseenter": function(){
				if(!$header.hasClass("sub")){
					hoverFlag = true;
					$("header#global_header").addClass("sub");
				}
			}
		});
		$("#glbnav_pc ul li a").not(".nav_technology").on({
			"mouseenter": function(){
				if(hoverFlag){
					hoverFlag = false;
					$("header#global_header").removeClass("sub");
				}
			}
		});
		$("#subnav").on({
			"mouseenter": function(){
				hoverFlag = true;
			},
			"mouseleave": function(){
				if(hoverFlag){
					hoverFlag = false;
					$("header#global_header").removeClass("sub");
				}
			}
		});
		$("#btn_menu").off().on("click", function(){
			if(!$body.hasClass("nav")){
				$body.addClass("nav");
			}else{
				$body.removeClass("nav");
			}
		});
		$("a.btn_toggle").off().on("click", function(){
			var $this = $(this).parent();
			if(!$this.hasClass("open")){
				$this.addClass("open");
			}else{
				$this.removeClass("open");
			}
			$this.find(".accordion").animate({
				height: "toggle", opacity: "toggle"
			},400);
		});
		$("#btn_lang").off().on("click", function(){
			$(".list_lang").animate({
				height: "toggle", opacity: "toggle"
			}, 200);
		});
		$("#select_lang select").off().on("change", function(){
			let url = $(this).find(":selected").val();
			location.href = url;
		});
		
		//share
		$(".sharewith li a").off().on("click", function(){
			$this = $(this);
			var idx = $(".sharewith li a").index(this);
			var url = $(this).attr("data-share");
			shareTxt(idx,url);
		});
		function shareTxt(num,shareUrl){
			var domain = "http://" + document.domain;
			var url 	= domain + shareUrl;
			if(num === 0){
				//Twitter
				var txt = $this.attr("data-text");
				window.open(
					'http://twitter.com/share?url=' + encodeURIComponent(url) + "&amp;text=" + encodeURIComponent(txt),
					'twittersharedialog',
					'width=626,height=436');
			}else if(num === 1){
				//Facebook
				window.open(
					'http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
					'facebooksharedialog',
					'width=626,height=436');
			}else{
				//LINE
				var txt = $this.attr("data-text") + "\n" + url;
				window.open(
					'http://line.me/R/msg/text/?' + encodeURIComponent(txt),
					'linesharedialog',
					'width=626,height=436');
			}
		}
		let $btnArchives = $("#btn_archives");
		$btnArchives.off().on("click", function(){
			if(!$btnArchives.hasClass("active")){
				$btnArchives.addClass("active");
			}else{
				$btnArchives.removeClass("active");
			}
			$("#list_archives").animate({
				height: "toggle", opacity: "toggle"
			},400);
		})
	},
	resize: ()=>{
		let winW = window.innerWidth;
		let winH = window.innerHeight;
		let $body = $("body"),
			beforeW = 0;

		if (window.matchMedia('all and (min-width : 864px)').matches) {
			isSmallScreen = false;
		} else if(window.matchMedia('all and (min-width : 0px)').matches) {
			isSmallScreen = true;
		}
		if(winW != beforeW){
			common.checkBlock();
			var _h = window.innerHeight;
			if(_h >= 600){
				_h = 600;
			}
			if(page.isPage === "home"){
				home.resize();
				if(isSmallScreen){
					if(beforeW != winW){
						$("#bg").css("height", Math.floor(window.innerHeight - 50) + "px");
					}
				}else{
					$("#bg").css("height", Math.floor(window.innerHeight) + "px");
				}
			}else{
				if(isSmallScreen){
					$("#page_main").css({
						"height": Math.floor(winW*.8) + "px"
					});
					$("#bg").css("height", Math.floor(winW*.8) + "px");
				}else{
					$("#page_main").css({
						"height": _h + "px"
					});
					$("#bg").css("height", "");
				}
			}
		}
		beforeW = winW;
		setTimeout(function(){
			if($body.hasClass("resize")){
				$body.removeClass("resize");
			}
		},300);
	},
	checkBlock: function(){
		animations = [];
		$(".a").each(function(i){
			var _a 	= object(Animate);
			if(page.isPage != "home"){
				_a.top 	= Math.floor($(this).offset().top);
				_a.show = Math.floor(_a.top + $(window).height()/3);
			}else{
				_a.top 	= Math.floor($(this).offset().top - $("#block_scroll").offset().top);
				_a.show = Math.floor(_a.top + $(window).height()/3);
			}
			
			animations.push(_a);
		});
		//console.log(animations);
		$(document).off("scroll").on("scroll", function(){
			common.scrl();
		});
	},
	scrollToPosition: (posY) =>{
		var $page 	= $("html,body"),
			ease 	= "easeInOutCubic",
			flag 	= true;
		$page.animate({
			scrollTop : posY + "px"
		},{
			"duration" 	: 1000,
			"easing" 	: ease,
			"complete"	: function(){
				if(flag){
					flag = false;
				}
			}
		});
	},
	scrl: () =>{
		var topD = $(document).scrollTop(),
			btmD = topD + $(window).height(),
			alen = animations.length;

		if(page.isPage === "about"){
			//common.scrlAbout(topD, btmD);
		}
		for(var a = 0; a < alen; a++){
			if(a === alen - 1){
				if(btmD >= animations[a].show){
					activeAnimation(a)
				}
			}else{
				//console.log(btmD, animations[a].show)
				if(btmD >= animations[a].show){
					activeAnimation(a)
				}
			}
		}
		function activeAnimation(a){
			var $block = $(".a").eq(a);
			if(!$block.hasClass("animate")){
				$block.addClass("animate");
				setTimeout(function(){
					$block.addClass("animated");
				},1000);
			}
		}
	},
	scrlAbout: function(topD, btmD){
		//画像をスクロール値によって固定させる
		let $col2 		= $("#about1 .page_col2");
		let stopPos 	= $col2.offset().top - $("header").height() - 70,
			$about02 	= $("#about1"),
			upPos 		= $("#global_footer").offset().top - 40;
		//console.log(upPos, topD)
		if(topD >= stopPos){
			if(!$about02.hasClass("fix")){
				$about02.addClass("fix");
			}
		}else{
			if($about02.hasClass("fix")){
				$about02.removeClass("fix");
			}
		}
		//console.log(topD, upPos)
		if(btmD >= upPos){
			if(!$about02.hasClass("btm")){
				$about02.addClass("btm");
				$about02.find("figure").css({
					"bottom": "0px",
					"top": "auto"
				});
			}
		}else{
			if($about02.hasClass("btm")){
				$about02.removeClass("btm");
				$about02.find("figure").css({
					"top": "",
					"bottom": ""
				});
			}
		}
	},
	mouseCursor: function(){
		window.document.addEventListener("mousemove", getMousePos, false);
		function getMousePos(e){
			mouse[0] = e.clientX;
			mouse[1] = e.clientY;
		}
	},
	checkBlockID: function(){
		var parameter 	= location.search.substring(1);
		var pair 		= parameter.split('&');
		for(var i = 0; pair[i]; i++) {
			var kv = pair[i].split('=');
			if(kv[0] === "block"){
				var blockID = kv[1];
				var posY = $('#content [data-name="' + blockID + '"]').offset().top - $("header").outerHeight();
				common.scrollToPosition(posY);
			}
		}
	},
	checkNews: function(){
		var folders = location.pathname.split("/"),
			len = folders.length;
		$(".block_side li a").removeClass("active");
		
		if(folders[1] === "en"){
			if(len === 5){
				var current = folders[len-2];
			}else if(len === 6){
				var current = folders[len-3]
			}else if(len === 7){
				var current = folders[len-4]
			}
			if(isNum(current)){
				var ttl = "News by " + current
			}else{
				var ttl = current;
				ttl = ttl.replace("-", " ");
			}
		}else{
			if(len === 4){
				var current = folders[len-2];
			}else if(len === 5){
				var current = folders[len-3]
			}else if(len === 6){
				var current = folders[len-4]
			}
			if(isNum(current)){
				var ttl = current + "年のニュース"
			}else{
				var ttl = current;
				ttl = ttl.replace("-", " ");
			}
		}
		$("#block_bread li.cat").html(ttl);
		
		
		$(".block_side li").each(function(){
			var $this = $(this);
			var dname = $(this).find("a").attr("data-name");
			if(dname === current){
				$this.find("a").addClass("active");
			}
		});
		function isNum(val){
			var regex = new RegExp(/^[-+]?[0-9]+(\.[0-9]+)?$/);
			return regex.test(val);
		}
	}
}
document.addEventListener('DOMContentLoaded', function () {
	isPage = $("body").attr("id");
	common.init();
});